import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f266e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar" }
const _hoisted_2 = ["src"]

import { onBeforeMount, ref, Ref, watch, withDefaults } from 'vue';
import defaultImage from '@courseur/assets/images/default-avatar.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    src: { default: null }
  },
  setup(__props: any) {

const props = __props;



let imgSrc: Ref<string> = ref('');

watch(() => props.src, (src) => {
    imgSrc.value = src || defaultImage;
})

onBeforeMount(() => {
    imgSrc.value = props.src || defaultImage;
})

const handleError = () => {
    imgSrc.value = defaultImage;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(imgSrc),
      onError: handleError
    }, null, 40, _hoisted_2)
  ]))
}
}

})